
import $ from 'jquery';

import MyLocalStorage from './../general/LocalStorage';

import ClickAndReserveMap from './ClickAndReserveMap';
import ClickAndReserveForm from './ClickAndReserveForm';

let shouldViewRes = true;

/**
 * The Upper Part of the ClickAndReserve Popup.
 */
class ClickAndReservePopup {

	constructor( containerEl ) {

		this.$container = $( containerEl );

		this.$container.on( 'change', '#shipping-location-select', () => this.onChangeLocation() );

		// Update Availability Table on Colorchange.
		this.$container.on( 'change', '.mdl_stock_reserve__article_color .acl_js--color_choice_input', () => this.onChangeColor() );

		// Update Events.
		this.$container.on( 'load_productmain_quick_stock.acl', () => this.refresh() );

		// Setup subclasses for Form and Map.
		this.Map = new ClickAndReserveMap( containerEl );
		this.Form = new ClickAndReserveForm( containerEl );

		// Refresh, when select exists.
		if ( $( '#shipping-location-select' ).length > 0 ) {
			this.refresh();
		}
	}

	refresh() {
		this.preSelectLocation();
	}

	preSelectLocation() {

		// Get Previous.
		const previous = MyLocalStorage.getItem( 'LAST_PQL' );

		if ( previous ) {
			$( '#shipping-location-select' ).val( previous );
		}

		// Trigger Preselection.
		this.onChangeLocation();
	}

	onChangeLocation() {

		const $select = $( '#shipping-location-select' );

		// Set current value to Storage.
		MyLocalStorage.setItem( 'LAST_PQL', $select.val() );

		// Update Location Details.
		this.setLocationDetails();

		if ( $select.attr( 'data-should-see-reservation' ) ) {
			shouldViewRes = true;
		} else {
			const clickAndCollect = $select.find( ':selected' ).data( 'cc' );
			shouldViewRes = clickAndCollect;
		}

		// Update Bestand Table.
		this.updateAvailabilityTable();
	}

	setLocationDetails() {

		const $select = $(  '#shipping-location-select' );
		const $parent = $( '.mdl_stock_reserve__location' );

		// Select first, if no other option was set yet.
		if ( $select.prop( 'selectedIndex' ) <= 0 ) {
			$select.prop( 'selectedIndex', "1" )
			MyLocalStorage.setItem( 'LAST_PQL', $select.val() );
		}

		// Get Data.
		const data = $select.find( ":selected" ).data();

		if(data)
		{
			// General Address Info.
			const leftContent = `
			<div class="location_info">${data.info}</div>
			<div class="location_address">${data.address}</div>
			<div class="location_email"></div>
			<div class="location_phone">${data.phone}</div>`;
			$parent.find( '.location_address' ).html( leftContent );

			// Opening Hours.
			const rightContent = `
			<div class="location_openinghours__heading">Öffnungszeiten:</div>` +
			data.openHours.split( '||' ).map(
				( val ) => `<div class="location_openinghours__entry">${val.trim().replace('<b>', ' <b>')}</div>`
			).join( "\n" );
			$parent.find( '.location_openinghours' ).html( rightContent );

			// Update Opening Hours Visibility.
			if (data && data.openHours && data.openHours.length) {
			$parent.find('.location_openinghours').show();
			} else {
			$parent.find('.location_openinghours').show();
			}
		}



		// Trigger dependent events, like the map-update.
		this.$container.each( function( idx, containerEl ) {
			containerEl.dispatchEvent( new CustomEvent( 'update_location.acl', { bubbles: true } ) );
		})
	}

	onChangeColor() {
		this.updateProductInfos();
		this.updateAvailabilityTable();
	}

	updateProductInfos()  {
		const $select = $( '#shipping-location-select' );
		const $radio = this.$container.find( '.mdl_stock_reserve__article_color .acl_js--color_choice_input:checked' );

		return $.ajax({
			url: window.location.href,
			type: "GET",
			data: {
				anid: $select.data( 'anid'),
				quickview: 2,
				varselid: [
					$radio.data( 'selection-id' )
				]
			},
		})
		.promise()
		.then( (response) => {

			// Get response as jquery.
			const $response = $( response );

			const elements = [
				".mdl_stock_reserve__header .mdl_stock_reserve__article_image",
				".mdl_stock_reserve__header .mdl_stock_reserve__article_data .article_label",
				".mdl_stock_reserve__header .mdl_stock_reserve__article_data .article_name",
				".mdl_stock_reserve__header .mdl_stock_reserve__article_data .article_price_wrapper",
				".mdl_stock_reserve__header .mdl_stock_reserve__article_color .en_mdl_article_detail__chosen_color_val"
			];

			// Replace all srcEls with the new Elements from the AJAX response.
			elements.forEach( ( selector ) => {

				const $srcEl = this.$container.find( selector );
				const $newEl = $response.find( selector );

				if ( $srcEl.is( 'img' ) ) {
					$srcEl.attr( 'src', $newEl.attr( 'src' ) );
				} else {
					$srcEl.replaceWith( $newEl ).fadeIn( 200 );
				}
			});
		});
	}

	updateAvailabilityTable() {

		const $select = $( '#shipping-location-select' );
		const $ccolor = this.$container.find( '.mdl_stock_reserve__article_color .acl_js--color_choice_input:checked' );

		let dropSelectedStore = $select.val();
		let dropSelectedColor = $ccolor.val();

		if ( dropSelectedStore && dropSelectedColor ) {

			$(".sizetable").hide();

			$.cookie("vsubsidiarynumber", dropSelectedStore, { path: '/' });

			window.v_marketpreferedshippingid = dropSelectedStore;
			window.vFull = dropSelectedStore;

			if (dropSelectedStore > 2000) {
				dropSelectedStore = dropSelectedStore - 2000;
			} else {
			 if (dropSelectedStore > 1000) {
				 dropSelectedStore = dropSelectedStore - 1000;
			 }
			}

			return $.ajax({
				type: 'GET',
				url: '/index.php',
				data: {
					'cl': 'marketsubsidiarystock',
					'subsidiarynumber': dropSelectedStore,
					'partnumber': $select.attr( 'data-product' ),
					'ajax': 1,
				}
			})
			.promise()
			.then( (response) => {

				if ( $.trim( response ) == '' ) {
					throw "Empty Response";
				}

				const $response = $( response );

				// Convert articles to JSON Object.
				const articles = [];
				$( '.artikel', $response ).each(function () {

					const $article = $( this );
					articles.push({
						'id': $article.attr( 'id' ),
						'variante': $article.find( '.variante' ).html(),
						'bestand': parseInt( $article.find( '.bestand' ).html() ),
						'shopbestand': parseInt( $article.find( '.shopbestand' ).html() ),
						'oxid': $article.find( '.oxid' ).html(),
					} );
				} );

				return articles;
			})
			.then( (articles) => {

				const isClickAndReserve = $('option:selected', '#shipping-location-select').attr('data-attr-clickandreserve');

				$("#aenderungs_info").css('visibility', 'visible');
				$(".mdl_stock_reserve__matrix").css('visibility', 'visible');
				$(".mdl_stock_reserve__matrix").css('display', 'block');
				$(".table_wrapper .table_body .table_row").hide();

				articles.forEach( ( article ) => {

					// Use .attr('id') instead of .find( #${article.id} ) because the query Selector may fail with specific ids.
					const $tableRow = this.$container.find( '.mdl_stock_reserve__matrix .table_row' ).filter( function() {
						return $( this ).attr( 'id' ) === article.id;
					} );

					const $icon = $tableRow.find( '.table_stock__message .table_stock__message_icon' );
					const $message = $tableRow.find( '.table_stock__message .table_stock__message_text' );
					const $actions = $tableRow.find( '.table_stock__actions [data-action]' );

					// Show Tablerow.
					$tableRow.show();

					// Hide Row Elements.
					$message.addClass( 'en_hidden' );
					$actions.addClass( 'en_hidden' );

					// Check current stock status.
					switch ( article.bestand ) {

						// not in stock.
						case 0:

							$icon.attr( 'class', 'table_stock__message_icon icon icon--medium icon_availability_empty' );
							$message.filter( '[data-message="no_stock"]' ).removeClass( 'en_hidden' );

							if ( article.shopbestand > 0 ) {
								// We can deliver the item anyway via c&c, if we have it in online shop.
								$actions.filter( '[data-action="to_basket"]').removeClass( 'en_hidden' ).attr( 'data-oxid', article.oxid );
							} else {
								// Else it is just not reservable.
								$actions.filter( '[data-action="not_reservable"]').removeClass( 'en_hidden' );
							}
						break;

						// 1 or 2 means low stock.
						case 1:
						case 2:

							$icon.attr( 'class', 'table_stock__message_icon icon icon--medium icon_availability_medium' );
							$message.filter( '[data-message="low_stock"]' ).removeClass( 'en_hidden' );
							$actions.filter( '[data-action="reserve"]').removeClass( 'en_hidden' ).val( article.variante );
						break;

						// Three or higher.
						case 3:
						default:

							$icon.attr( 'class', 'table_stock__message_icon icon icon--medium icon_availability_full' );
							$message.filter( '[data-message="has_stock"]' ).removeClass( 'en_hidden' );
							$actions.filter( '[data-action="reserve"]').removeClass( 'en_hidden' ).val( article.variante );
						break;
					}

					// If the location does not support Click and Reserve.
					if ( isClickAndReserve != 1 ) {
						$actions.addClass( 'en_hidden' ).filter( '[data-action="not_reservable"]').removeClass( 'en_hidden' );
					}

					// Show or hide the reservable Button.
					if ( shouldViewRes ) {
						$tableRow.find( '.table_stock__actions' ).removeClass( 'en_hidden' );
					} else {
						$tableRow.find( '.table_stock__actions' ).addClass( 'en_hidden' );
					}
				} );

				// Show Table for the selected color.
				const $sizeTable = this.$container.find( '.sizetable' ).filter( function() {
					return $( this ).attr( 'data-color' ) === dropSelectedColor;
				});
				$sizeTable.show();

				// Initialise Add to Basket function.
				if ( 'function' === typeof window.initializeAddToBasket ) {
					initializeAddToBasket();
				}

				EN_KO.functions.toggleSlide( $( '.mdl_stock_reserve__matrix' ), true );
			} );
		}

		// Hide Form and show table again.
		this.Form.reset();
	}

	static initPopup = ( selector ) => {

		$( selector ).each( function() {
			if ( ! $( this ).data( 'clickandreserve' ) ) {
				const instance = new ClickAndReservePopup( this );
				$( this ).data( 'clickandreserve', instance );
			}
		} );
	}
}

$( document ).ready( function() {

	const $popup = $( '#popup_click_and_reserve' );

	if ( $popup.length > 0 ) {

		// Initialise Popup.
		ClickAndReservePopup.initPopup( $popup );
	}

} );

$(document).on( 'finished_change_variant', function() {

	const $popup = $( '#popup_click_and_reserve' );

	if ( $popup.length > 0 ) {

		// Initialise Popup.
		ClickAndReservePopup.initPopup( $popup );
	}

} );

export default ClickAndReservePopup;
